import PropTypes from 'prop-types'
import React from 'react'
import { withRouter } from 'react-router-dom'
import classNames from 'classnames'

import Dropdown from '../../../shared/components/dropdown'
import { commaStyleString } from '../../../../common/utils/formatString'
import filterParamsConfig from '../../../../common/constants/filterParamsConfig'

const FiltersDropdown = ({
  name,
  label,
  locationParams,
  history,
  items = [],
  ignoreOptions = [],
  prependShowAllOption = true,
  isAtBottom,
  isAtTop,
  makeSearchLink
}) => {
  const config = filterParamsConfig[name]
  const id = `${name}-filter`
  const chosenOption = locationParams[name] || ''
  const prependLabel = `${label}: `

  const prependActiveLabel = option => {
    return {
      value: option.value,
      label:
        chosenOption === option.value
          ? `${prependLabel}${option.label}`
          : option.label
    }
  }

  const filterIgnoredOptions = option => {
    return !ignoreOptions.includes(option.key)
  }

  const sortOptions = (opt1, opt2) => {
    if (config.labels) {
      let keys = Object.keys(config.labels)

      if (config.shouldSort) {
        keys = keys.sort()
      }

      return keys.indexOf(opt1.key) - keys.indexOf(opt2.key)
    }

    return opt1.key > opt2.key
  }

  const applyLabels = option => {
    let label

    if (option.key) {
      label =
        (config.labels && config.labels[option.key]) ||
        (config.format && config.format(option.key)) ||
        option.key
      label =
        option.count !== '' && option.count !== 0
          ? `${label} - ${commaStyleString(option.count)}`
          : label
    } else {
      label = 'Show All'
    }

    return {
      value: option.key,
      label
    }
  }

  // build the show all option
  const showAllOption = {
    count: '',
    description: null,
    key: ''
  }

  const options = (prependShowAllOption ? [showAllOption, ...items] : items)
    .filter(filterIgnoredOptions)
    .sort(sortOptions)
    .map(applyLabels)
    .map(prependActiveLabel)

  const onSelectionChange = event => {
    const value = event.target.value

    let newQuery = Object.assign({}, locationParams, {
      [name]: value
    })
    delete newQuery.page

    if (newQuery[name] === '') {
      delete newQuery[name]
    }

    history.push(makeSearchLink(newQuery))
  }

  const panelHeaderClassNames = classNames('group-select', {
    '-border-top-none': !isAtTop,
    '-border-radius-none': !isAtBottom && !isAtTop,
    '-border-radius-bottom': isAtBottom,
    '-border-radius-top': isAtTop
  })

  const Icon = config.icon

  return (
    <div id={id}>
      <div className={panelHeaderClassNames}>
        <div className="search-facet-header">
          <h2>
            <Icon />
          </h2>
        </div>
        <label className="fds-u-is-visually-hidden" htmlFor={`${name}-label`}>
          {label}
        </label>
        <Dropdown
          id={`${name}-label`}
          name={name}
          options={options}
          onChange={onSelectionChange}
          value={chosenOption}
        />
      </div>
    </div>
  )
}

FiltersDropdown.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  locationParams: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  items: PropTypes.array,
  ignoreOptions: PropTypes.array,
  isAtBottom: PropTypes.bool,
  isAtTop: PropTypes.bool,
  makeSearchLink: PropTypes.func.isRequired
}

export const FiltersDropdownComponent = FiltersDropdown
export default withRouter(FiltersDropdown)
